import "./UserDashboard.css";
import UserSidebar from "./Components/UserSidebar";
import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { ethers } from "ethers";

const RejectedNFTs = () => {
    const [rejectedNFTs, setRejectedNFTs] = useState([]);
    const [currentUserAddress, setCurrentUserAddress] = useState("");
    const [selectedNft, setSelectedNft] = useState(null);
    const [showModal, setShowModal] = useState(false);
  
    const handleShowModal = (nft) => {
      setSelectedNft(nft);
      setShowModal(true);
    };
  
    const handleCloseModal = () => setShowModal(false);
    useEffect(() => {
      fetchRejectedNFTs();
      getCurrentUserAddress();
    }, []);
    function formatAddress(address) {
        return `${address.slice(0, 3)}...${address.slice(-4)}`;
      }
    async function fetchRejectedNFTs() {
      try {
        const response = await axios.get("https://mint-blocks-api-production.up.railway.app/rejected");
        setRejectedNFTs(response.data);
      } catch (error) {
        console.error(error);
      }
    }
  
    async function getCurrentUserAddress() {
      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const address = await signer.getAddress();
        setCurrentUserAddress(address);
      } catch (error) {
        console.error(error);
      }
    }
  
    function renderRejectedNFTs() {
      const myNfts = rejectedNFTs.filter((nft) => nft.sellerAddress === currentUserAddress);
      return myNfts.map((nft) => (
        <>
        <tr key={nft.tokenId}>
      
          <td>{nft.name}</td>
          <td>{nft.description}</td>
          <td>
            <img
              src={nft.fileUrl}
              alt=""
              className="rounded fluid"
              height={40}
              onClick={() => handleShowModal(nft)}
            />
          </td>
          <td>{nft.price}</td>
          <td>{formatAddress(nft.sellerAddress)}</td>
          <td>{nft.reason}</td>
        </tr>
        
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Body>
            {selectedNft && (
              <img src={selectedNft.fileUrl} alt="" className="img-fluid" />
            )}
          </Modal.Body>
        </Modal></>
      ));
    }

  return (
    <div className="container user-dashboard-page">
      <div className="user-sidebar">
        <UserSidebar />
      </div>
      <div className="user-main container">
        <div className="heading">
          <h3 className="mt-3">Rejected NFTs</h3>
          <p>All rejected NFTs are listed below</p>
        </div>
        {rejectedNFTs.length === 0 ? (
          <p>No rejected NFTs to display.</p>
        ) : (
          <table className="table">
            <thead>
              <tr className="table-light">
               
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Image</th>
                <th scope="col">Price</th>
                <th scope="col">Seller Address</th>
                <th scope="col">Reason</th>
              </tr>
            </thead>
            <tbody>{renderRejectedNFTs()}</tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default RejectedNFTs;
